<template>
  <div class="container page withdraw-page">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push('/WithdrawRecord')">
          {{ $t('withdraw.with_record') }}
        </span>
      </template>
    </van-nav-bar>

    <div class="main-content">
      <div class="withdraw-card">
        <div class="card-label">{{ $t('withdraw.with_money') }}</div>
        <div class="amount-row">
          <span class="currency-tag">TWD</span>
          <input
            v-model="withdraw_money"
            type="number"
            class="amount-input"
            :placeholder="amountPlaceholder"
          />
          <span class="all-btn" @click="fillAll">{{ $t('withdraw.all') }}</span>
        </div>
        <div class="balance-line">
          {{ $t('withdraw.available_balance') }}：
          <span class="balance-num">{{ availableBalance }} TWD</span>
        </div>

        <div class="bank-card" @click="goBankPage">
          <template v-if="hasBank">
            <van-icon name="card" class="bank-icon" />
            <div class="bank-detail">
              <span class="bank-name">{{ bankInfo.bankinfo }}</span>
              <span class="bank-num">{{ maskBankId(bankInfo.bankid) }}</span>
            </div>
            <van-icon name="checked" class="check-icon" />
          </template>
          <template v-else>
            <van-icon name="plus" class="bank-icon add-icon" />
            <span class="add-bank-text">{{ $t('setting.add_bank') }}</span>
          </template>
        </div>
      </div>

      <button class="submit-btn" @click="doWithdraw()">
        {{ $t('withdraw.apply') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      withdraw_money: '',
      userInfo: {},
      withdrawRole: {},
      bankInfo: {},
      hasBank: false
    }
  },
  computed: {
    availableBalance() {
      const balance = parseFloat(this.userInfo.money)
      return Number.isFinite(balance) ? balance.toFixed(2) : '0.00'
    },
    amountPlaceholder() {
      return `${this.$t('withdraw.available_balance_short')}${this.availableBalance}`
    }
  },
  methods: {
    getCurrentLevel() {
      if (!this.userInfo.all_levels || !this.userInfo.vip) return null
      return this.userInfo.all_levels.find(level => level.name === this.userInfo.vip)
    },
    getCurrentLevelWithdrawMax() {
      const level = this.getCurrentLevel()
      if (level) return parseFloat(String(level.withdraw_max_amount).replace(/,/g, ''))
      if (this.withdrawRole.max) return parseFloat(this.withdrawRole.max)
      return 0
    },
    getCurrentLevelWithdrawMin() {
      const level = this.getCurrentLevel()
      if (level) return parseFloat(level.withdraw_min_amount)
      if (this.withdrawRole.min) return parseFloat(this.withdrawRole.min)
      return 0
    },
    fillAll() {
      const balance = parseFloat(this.userInfo.money) || 0
      const maxAmount = this.getCurrentLevelWithdrawMax()
      const amount = maxAmount > 0 ? Math.min(balance, maxAmount) : balance
      this.withdraw_money = amount > 0 ? amount.toFixed(2) : ''
    },
    back() {
      return window.history.back()
    },
    goBankPage() {
      this.$router.push({ path: '/Setbank' })
    },
    maskBankId(value) {
      if (!value) return ''
      const raw = String(value).replace(/\s/g, '')
      if (raw.length <= 8) return raw
      const first = raw.slice(0, 4)
      const last = raw.slice(-4)
      const middleGroupCount = Math.ceil((raw.length - 8) / 4)
      const middle = Array(middleGroupCount).fill('****').join(' ')
      return `${first} ${middle} ${last}`
    },
    getUserBankInfo() {
      this.$http({ method: 'get', url: 'user_get_bank' }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.hasBank = true
            this.bankInfo = res.data.info || {}
          } else {
            this.hasBank = false
            this.bankInfo = {}
          }
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    getUserWithdrawRole() {
      this.$http({ method: 'get', url: 'user_get_withdraw_role' }).then(res => {
        if (res.code === 200) {
          this.withdrawRole = res.data
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    doWithdraw() {
      if (!this.hasBank) {
        this.$toast.fail(this.$t('setting.set_bank'))
        this.$router.push({ path: '/Setbank' })
        return false
      }
      if (!this.withdraw_money || this.withdraw_money <= 0) {
        this.$toast(this.$t('setting.correct_money'))
        return false
      }

      const amount = parseFloat(this.withdraw_money)
      const minAmount = this.getCurrentLevelWithdrawMin()
      const maxAmount = this.getCurrentLevelWithdrawMax()
      const balance = parseFloat(this.userInfo.money)

      if (minAmount > 0 && amount < minAmount) {
        this.$toast(`${this.$t('withdraw.min_amount_error')} ${minAmount}`)
        return false
      }
      if (maxAmount > 0 && amount > maxAmount) {
        this.$toast(`${this.$t('withdraw.max_amount_error')} ${maxAmount}`)
        return false
      }
      if (amount > balance) {
        this.$toast(this.$t('withdraw.insufficient_balance'))
        return false
      }

      this.$http({
        method: 'post',
        data: { money: this.withdraw_money, paypassword: '' },
        url: 'user_set_withdraw'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg)
          this.getUserInfo()
          this.getUserWithdrawRole()
          this.withdraw_money = ''
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo()
      this.getUserWithdrawRole()
      this.getUserBankInfo()
    }
  },
  activated() {
    if (localStorage.getItem('token')) {
      this.getUserBankInfo()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

.withdraw-page {
  background: #f2f2f5;
}

.main-content {
  padding: 0.75rem;
}

.withdraw-card {
  background: #fff;
  border-radius: 0.625rem;
  padding: 1rem 0.875rem 0.875rem;
  box-shadow: 0 0.13333rem 0.2rem rgba(0, 0, 0, 0.04);

  .bank-card {
    display: flex;
    align-items: center;
    margin-top: 0.875rem;
    padding-top: 0.875rem;
    border-top: 1px solid #eee;
    cursor: pointer;
  }
}

.bank-card {
  .bank-icon {
    flex-shrink: 0;
    font-size: 1.5rem;
    color: #5b7fd6;
    margin-right: 0.75rem;

    &.add-icon {
      color: #8056e3;
    }
  }

  .bank-detail {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    .bank-name {
      font-size: 1rem;
      font-weight: 600;
      color: #333;
      line-height: 1.3;
    }

    .bank-num {
      font-size: 0.875rem;
      color: #999;
      word-break: break-all;
      line-height: 1.3;
    }
  }

  .check-icon {
    flex-shrink: 0;
    font-size: 1.375rem;
    color: #07c160;
    margin-left: 0.5rem;
  }

  .add-bank-text {
    flex: 1;
    font-size: 0.9375rem;
    color: #8056e3;
    font-weight: 500;
  }
}

.card-label {
  font-size: 0.9375rem;
  color: #333;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.amount-row {
  display: flex;
  align-items: center;
  padding: 0.625rem 0;
  border-bottom: 1px solid #eee;
}

.currency-tag {
  flex-shrink: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-right: 0.625rem;
}

.amount-input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 1rem;
  color: #333;

  &::placeholder {
    color: #bbb;
    font-size: 0.875rem;
  }
}

.all-btn {
  flex-shrink: 0;
  font-size: 0.9375rem;
  color: #8056e3;
  padding-left: 0.5rem;
  cursor: pointer;
}

.balance-line {
  margin-top: 0.75rem;
  font-size: 0.875rem;
  color: #666;

  .balance-num {
    color: #c94d9a;
    font-weight: 600;
  }
}

.submit-btn {
  display: block;
  width: 100%;
  height: 3rem;
  margin-top: 1.25rem;
  border: none;
  border-radius: 1.5rem;
  color: #fff;
  font-size: 1.0625rem;
  font-weight: 600;
  background: linear-gradient(90deg, #f560cd, #8056e3);
}
</style>
